/*
 * @Author: xuning 1373543909@qq.com
 * @Date: 2024-03-06 16:53:29
 * @LastEditors: xuning 1373543909@qq.com
 * @LastEditTime: 2024-03-07 17:24:52
 * @FilePath: \vue-admin-template-master\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'

import EditKrpano from "../views/editKrpano.vue";
import Krpano from "../views/krpano.vue";
// import { component } from 'vue/types/umd';
Vue.use(Router)

export const constantRoutes = [
  {
    path: '/editKrpano',
    component:EditKrpano,
    name: 'editKrpano',
    // component: () => import('@/views/editKrpano.vue'),
    // hidden: true
  },
  {
    path: '/',
    component:Krpano,
    name: 'Krpano',
    // component: () => import('@/views/krpano.vue'),
    // hidden: true
  },
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  console.log(newRouter)
  router.matcher = newRouter.matcher // reset router
}

export default router
